var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 26.5,
    fill: "#FF4444"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 53,
    height: 53,
    rx: 26.5,
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0625 26.2186L21.3125 20.9686C21.6042 20.6769 21.9479 20.4686 22.3438 20.3436C22.7396 20.2186 23.1458 20.1978 23.5625 20.2811L25.1875 20.6249C24.0625 21.9582 23.1771 23.1665 22.5312 24.2499C21.8854 25.3332 21.2604 26.6457 20.6562 28.1874L16.0625 26.2186ZM22.4688 29.0624C22.9479 27.5624 23.599 26.1457 24.4219 24.8124C25.2448 23.479 26.2396 22.229 27.4062 21.0624C29.2396 19.229 31.3333 17.8592 33.6875 16.953C36.0417 16.0467 38.2396 15.7707 40.2812 16.1249C40.6354 18.1665 40.3646 20.3644 39.4688 22.7186C38.5729 25.0728 37.2083 27.1665 35.375 28.9999C34.2292 30.1457 32.9792 31.1405 31.625 31.9842C30.2708 32.828 28.8438 33.4894 27.3438 33.9686L22.4688 29.0624ZM31.0938 25.3124C31.5729 25.7915 32.1615 26.0311 32.8594 26.0311C33.5573 26.0311 34.1458 25.7915 34.625 25.3124C35.1042 24.8332 35.3438 24.2447 35.3438 23.5467C35.3438 22.8488 35.1042 22.2603 34.625 21.7811C34.1458 21.3019 33.5573 21.0624 32.8594 21.0624C32.1615 21.0624 31.5729 21.3019 31.0938 21.7811C30.6146 22.2603 30.375 22.8488 30.375 23.5467C30.375 24.2447 30.6146 24.8332 31.0938 25.3124ZM30.2188 40.3436L28.2188 35.7499C29.7604 35.1457 31.0781 34.5207 32.1719 33.8749C33.2656 33.229 34.4792 32.3436 35.8125 31.2186L36.125 32.8436C36.2083 33.2603 36.1875 33.6717 36.0625 34.078C35.9375 34.4842 35.7292 34.8332 35.4375 35.1249L30.2188 40.3436ZM18.0625 33.0624C18.7917 32.3332 19.6771 31.9634 20.7188 31.953C21.7604 31.9426 22.6458 32.3019 23.375 33.0311C24.1042 33.7603 24.4688 34.6457 24.4688 35.6874C24.4688 36.729 24.1042 37.6144 23.375 38.3436C22.8542 38.8644 21.9844 39.3124 20.7656 39.6874C19.5469 40.0624 17.8646 40.3957 15.7188 40.6874C16.0104 38.5415 16.3438 36.8644 16.7188 35.6561C17.0938 34.4478 17.5417 33.5832 18.0625 33.0624Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRocket);
export default __webpack_public_path__ + "static/media/icon-rocket.735b2dee3c05a5205f3e2edc31722f0f.svg";
export { ForwardRef as ReactComponent };